<template>
    <div>
        <el-form size="mini" ref="approvalForms"  label-width="165px">
            <el-form-item style="font-weight: 700;margin-left: -97px;" label="表单信息" >
                <el-collapse class="process-detail-Forms" style="" v-if="isShowForm" v-model="collapseActiveName" @change="handleChangeCollapse3" accordion>
                    <el-collapse-item v-for="(form, index) in formArray" :key="form.id" :title="form.formName" :name="form.id">
                        <template slot="title">
                            <div class='el-collapse-title'>
                               <i class="header-icon el-icon-document">【{{form.formName}}】</i>
                                <div class="btns">
                                    <el-tooltip class="item" effect="light" content="查看关于当前数据的所有审批记录" placement="top">
                                        <el-button size="mini" icon="el-icon-view" @click.stop="handleShowApprovalRecordList(index)">查看全部审批记录</el-button>
                                    </el-tooltip>
                                    <el-button v-if="approvalTemplateObj && approvalTemplateObj.busiProcessInstanceId && isSecurities" size="mini" :loading="downloadFlg" type="primary"  title='证券服务业务备案信息报送表' icon="el-icon-download" @click.stop="handelDownloadReport">备案信息报送表</el-button>
                                    <el-button v-if="approvalTemplateObj && approvalTemplateObj.busiProcessInstanceId" size="mini" title='任务表单库' type="success" icon="el-icon-goods" @click.stop="handelShowForms">任务表单库</el-button>
                                    <el-button v-if="form.isApprovalFilterForm" size="mini" icon="el-icon-view" @click.stop="handleFromDataFilter(index,form)">查看待还款数据</el-button>
                                </div>
                            </div>
                            <el-button style="margin-right: 10px" size="mini" @click.stop="showModelDetail(form,index)" v-if="isShowBtn(form)">查看模型表单</el-button>
                        </template>
                        <el-form  :model="formData[index].values" :ref="'customForm'+index" label-width="165px" :id="`print${form.id}`">
                            <div :key="loadTimerField" >
                                <template v-for="(field,index2) in form.fieldsList" >
                                    <template v-if="isShowNormalField(field,index,formData[index])">
                                        <FieldItem
                                            :findex="index2" 
                                            :formIndex="index"
                                            :ref="'fieldItemChild'+index2"
                                            :formId="form.id"
                                            :formConfig="form"
                                            :key="field.fieldId"
                                            :field="field"
                                            :formData="formData[index].values"
                                            :colSpan="form.colSpan"
                                            :isView="field.isView"
                                            :isRead="isRead&&!((!field.approveFieldAuth||field.approveFieldAuth=='1')&&(approvalStatus==20||approvalStatus==23)&&btnMode==1)"
                                            :approvalUserList="approvalUserList"
                                            :processModelFormsObj="processModelFormsObj"
                                            :isBelongApproval="true"
                                            :fieldsList="form.fieldsList"
                                            :linkFieldCache="linkFieldCache"
                                            :relateModelList="relateModelList"
                                            @loadLinkData="loadLinkData"
                                            @refreshViewField="refreshViewField"
                                            @asynMainFormData="asynMainFormData"
                                            v-if="!field.formFieldAuth||field.formFieldAuth=='1'"
                                        />
                                    </template>
                                </template>
                                <div class="render-form-item" style="width: 100%; float: left;" v-if="(formData[index].values['subFormViewMode']!==0 && formData[index].ext1===1) || (formData[index].values['subFormViewMode'] && (formData[index].values['subFormViewMode'] > 0))">
                                    <el-row>
                                    <el-form-item label="" style="width: 100%;">
                                        <el-tabs :key="loadTimerField" v-model="defaultViewOrder" >
                                            <template v-for="(field,index2) in form.fieldsList" >
                                            <template v-if="field.type === 'subform' && (field.ext2 !== '1' || formData[index].values[field.id + '-casDefautShow'])" >
                                                <el-tab-pane  :key="index2" :label="getSubformName(formData[index].values,field)" :name="index2+''">
                                                    <FieldItem
                                                        :findex="index2"
                                                        :ref="'fieldItemChild'+index2"
                                                        :formId="form.id"
                                                        :formConfig="form"
                                                        :key="field.fieldId"
                                                        :field="field"
                                                        :formData="formData[index].values"
                                                        :isView="field.isView"
                                                        :colSpan="form.colSpan"
                                                        :isRead="isRead&&!((!field.approveFieldAuth||field.approveFieldAuth=='1')&&(approvalStatus==20||approvalStatus==23)&&btnMode==1)"
                                                        :approvalUserList="approvalUserList"
                                                        :processModelFormsObj="processModelFormsObj"
                                                        :isBelongApproval="true"
                                                        :fieldsList="form.fieldsList"
                                                        :subFormViewMode="1"
                                                        :linkFieldCache="linkFieldCache"
                                                        :relateModelList="relateModelList"
                                                        @loadLinkData="loadLinkData"
                                                        @refreshViewField="refreshViewField"
                                                        v-if="!field.formFieldAuth||field.formFieldAuth=='1'"
                                                    />
                                                </el-tab-pane>
                                            </template>
                                            </template>
                                        </el-tabs>
                                    </el-form-item>
                                    </el-row>
                                </div>
                            </div>
                            <!-- 关联的其他表单数据 -->
                              <div class="render-form-item" v-if="showRelateFormTab" style="width: 100%; float: left;">
                                <el-row>
                                  <el-form-item class="relateFormTab" label="" style="width: 100%;">
                                    <el-tabs :key="loadTimerRelate" @tab-click="handleRelateFormTabClick" v-model="relateFormTabName" >
                                        <template v-for="(model, index3) in relateModelList" >
                                            <el-tab-pane :key="model.id" :label="model.modelName" :name="model.id" v-if="!model.hiddenElement">
                                                <RelateFormList
                                                    :ref="'relateModelList' + model.id"
                                                    :key="loadTimerRelate"
                                                    :selectedModel="model"
                                                    :tempFormData="tempFormData"
                                                    :parentFormInfo="formInfo"
                                                    :parentFormData="formData"
                                                    :approvalStatus="approvalStatus"
                                                    :ifShowBtn="!approvalStatus"
                                                    @refTempFormData="refTempFormData"
                                                />
                                            </el-tab-pane>
                                        </template>
                                    </el-tabs>
                                </el-form-item>
                                </el-row>
                              </div>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
            </el-form-item>
        </el-form>
        <el-dialog
          title="模型表单"
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          append-to-body
          custom-class="detail-formPop"
          width="80%"
          top="2vh"
          >
          <el-form  :model="modelFormDetaulObj.modelFormDetaul.values" :key="loadTimerField" :ref="'customForm'+modelFormDetaulObj.index" label-width="165px" :id="`print${modelFormDetaulObj.id}`">
              <template v-for="(field,index2) in modelFormDetaulObj.fieldsList" >
                  <template v-if="isShowNormalField(field,modelFormDetaulObj.index,formData[modelFormDetaulObj.index])">
                      <FieldItem
                          :findex="index2"
                          :ref="'fieldItemChild'+index2"
                          :formId="modelFormDetaulObj.id"
                          :key="field.fieldId"
                          :field="field"
                          :formData="modelFormDetaulObj.modelFormDetaul.values"
                          :colSpan="modelFormDetaulObj.colSpan"
                          :isView="field.isView"
                          :isRead="isRead&&!((!field.approveFieldAuth||field.approveFieldAuth=='1')&&(approvalStatus==20||approvalStatus==23)&&btnMode==1)"
                          :approvalUserList="approvalUserList"
                          :processModelFormsObj="processModelFormsObj"
                          :isBelongApproval="true"
                          :fieldsList="modelFormDetaulObj.fieldsList"
                          :linkFieldCache="linkFieldCache"
                          :relateModelList="relateModelList"
                          @loadLinkData="loadLinkData"
                          @refreshViewField="refreshViewField"
                      />
                  </template>
              </template>
              <div class="render-form-item" style="width: 100%; float: left;" v-if="(modelFormDetaulObj.modelFormDetaul.values['subFormViewMode']!==0 && modelFormDetaulObj.modelFormDetaul.ext1===1) || (modelFormDetaulObj.modelFormDetaul.values['subFormViewMode'] && (modelFormDetaulObj.modelFormDetaul.values['subFormViewMode'] > 0))">
                  <el-row>
                  <el-form-item label="" style="width: 100%;">
                      <el-tabs :key="loadTimerField" v-model="defaultViewOrder" >
                          <template v-for="(field,index2) in modelFormDetaulObj.fieldsList" >
                          <template v-if="field.type === 'subform' && (field.ext2 !== '1' || modelFormDetaulObj.modelFormDetaul.values[field.id + '-casDefautShow'])" >
                              <el-tab-pane  :key="index2" :label="getSubformName(modelFormDetaulObj.modelFormDetaul.values,field)" :name="index2+''">
                                  <FieldItem
                                  :findex="index2"
                                  :ref="'fieldItemChild'+index2"
                                  :formId="modelFormDetaulObj.id"
                                  :key="field.fieldId"
                                  :field="field"
                                  :isView="field.isView"
                                  :formData="modelFormDetaulObj.modelFormDetaul.values"
                                  :colSpan="modelFormDetaulObj.colSpan"
                                  :isRead="isRead&&!((!field.approveFieldAuth||field.approveFieldAuth=='1')&&(approvalStatus==20||approvalStatus==23)&&btnMode==1)"
                                  :approvalUserList="approvalUserList"
                                  :processModelFormsObj="processModelFormsObj"
                                  :isBelongApproval="true"
                                  :fieldsList="modelFormDetaulObj.fieldsList"
                                  :subFormViewMode="1"
                                  :linkFieldCache="linkFieldCache"
                                  :relateModelList="relateModelList"
                                  @loadLinkData="loadLinkData"
                                  @refreshViewField="refreshViewField"
                                  />
                              </el-tab-pane>
                          </template>
                          </template>
                      </el-tabs>
                  </el-form-item>
                  </el-row>
              </div>
          </el-form>
        </el-dialog>
        <el-dialog
            title="未还款的表单数据"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowDataFilterDialog">
            <TableDataPop
                ref="tableDataFilterPop"
                :key="loadTimer"
                :isApprovalFilter="true"
                :modelId="currentModelId"
                >
            </TableDataPop>
        </el-dialog>
        <el-dialog
            title="任务表单库"
            top="1vh"
            width="80%"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowForms">
            <ProcessForms :processInfo="busiProcessInfo" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowForms=false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="审批记录"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowApprovalRecordListDialog">
            <ApprovalRecordList
                ref="approvalRecordListPop"
                :key="loadTimer"
                :modelInstanceId="currentModeInstanceId"
                >
            </ApprovalRecordList>
        </el-dialog>
    </div>
</template>

<script>
    import { isEmpty, cloneDeep } from 'lodash';
    import {getModelFormReportList, getProcessTaskInfo, getModelFormDetail, getModelListByMainFormId, getFormConfig, getAppAssignList, getProcessInstanceTaskPkId, getExcelDataExportId, getCrossFieldData} from '@/data-model';
    import RelateFormList from '@/pages/business/BusinessApplication/RelateFormList.vue';
    import ProcessForms from '@/pages/process/MyProcess/ProcessForms';
    import { getUUID } from '@/utils/grocer';
    import { API_EXPORT_MODEL_FORM_EXCEL, API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID } from '@/common/constants';
    export default {
        components: {
            ProcessForms,
            RelateFormList
        },
        data () {
            return {
                currentModeInstanceId: '',
                isShowApprovalRecordListDialog: false,
                busiProcessInfo: {},
                isShowForms: false,
                loadTimer: '',
                currentModelId: '',
                isShowDataFilterDialog: false,
                mainId: '',
                tempFormData: [], // 将要新增的关联表单数据
                showRelateFormTab: false,
                relateFormTabName: '',
                loadTimerRelate: '',
                relateModelList: [], // 关联的表单
                collapseActiveName: '',
                approvalBaseActiveName: '',
                approvalRecordActiveName: '',
                approvalUserActiveName: '',
                approvalSettingActiveName: '',
                isShowForm: false,
                loadTimerField: '',
                defaultViewOrder: null,
                formArray: [],
                dialogVisible: false,
                modelFormDetaulObj: [],
                isSecurities: false, // 是否涉及证券
                downloadFlg: false,
                linkFieldCache: new Map(),
                searchParamsField: {
                    modelId: '',
                    name: '',
                    selectedFields: '',
                    searchCondition: []
                },
                searchCondition: [],
                defaultConditonsMap: new Map(), // 默认设置关联数据的过滤条件map
                searchConditionExt: [],
                cacheRelateModelMap: new Map()
            };
        },
        props: {
            isRead: {
                type: Boolean,
                default: false
            },
            approvalStatus: {
                type: Number
            },
            btnMode: {
                type: Number,
                default: 0
            },
            forms: {
                type: Array,
                default: []
            },
            formData: {
                type: Array,
                default: []
            },
            approvalTemplateObj: {
                type: Object
            },
            processModelFormsObj: {
                type: Array
            },
            approvalUserList: {
                type: Array,
                default: []
            },
            isInstance: {
                type: Boolean,
                default: false
            },
            instances: {
                type: Object,
                default: function () {
                    return {
                        id: '',
                        formObj: {
                        }
                    };
                }
            }
        },
        watch: {
            'relateModelList' (newVal, oldVal) {
                let relateModelMap = this.cacheRelateModelMap;
                if (relateModelMap && relateModelMap.size > 0) { // 级联显示子表单控制
                    this.relateModelMap = new Map();
                    this.relateModelMap = relateModelMap;
                    if (this.relateModelList) {
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let model = this.relateModelList[i];
                            if (relateModelMap.has(model.id)) {
                                model.hiddenElement = !relateModelMap.get(model.id);
                                if (relateModelMap.get(model.id)) {
                                    this.showRelateFormTab = true;
                                }
                            }
                        }
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let cur = this.relateModelList[i];
                            if (!cur.hiddenElement) {
                                this.relateFormTabName = cur.id;
                                this.renderModelFormList(cur);
                                break;
                            }
                        }
                    }
                }
            }
        },
        mounted () {
            this.$nextTick(() => {
                if (!isEmpty(this.forms)) {
                    let formInfo = this.forms[0];// 默认第一个
                    if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                        this.loadTimerField = new Date().getTime();
                        let initUserArr = [];
                        for (var i = 0; i < formInfo.fieldsList.length; i++) {
                            let tempField = formInfo.fieldsList[i];
                            let tempRefName = 'fieldItemChild' + i;
                            if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                                setTimeout(() => {
                                // 设置下拉字段级联默认显示数据
                                    if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                        this.$refs[tempRefName][0].initDefaultCasData();
                                    }
                                }, 0);
                            }
                            if ((!this.defaultViewOrder || this.defaultViewOrder !== 0) && tempField.type === 'subform') { // 用来显示默认第一个子表单
                                this.defaultViewOrder = i + '';
                            }
                            if (tempField.type === 'user') {
                                initUserArr.push(tempRefName);
                            }
    
                            let tempFieldName = tempField.name;
                            if (tempFieldName === '是否证券') {
                                let instanceObj = JSON.parse(this.instances.formObj.instance);
                                let content = instanceObj[0].values[tempField.id];
                                if (content === '是' && formInfo.id === 'f87064ac5801493d8df940a0b44fe1bd') { // todo :等于报告打印单，并且是涉及证券的
                                    this.isSecurities = true;
                                }
                            }
                        }
                        for (var j = 0; j < initUserArr.length; j++) { // 针对人员级联初始化
                            let tempRefName = initUserArr[j];
                            setTimeout(async () => {
                                // 设置下拉字段级联默认显示数据
                                if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                    await this.$refs[tempRefName][0].setUserExtCascadeData(true);
                                }
                            }, 0);
                        }
                    }
                }
            });
        },
        computed: {
            sidebarOpened () {
                return this.appState.sidebar.opened;
            }
        },
        created () {
            this.linkFieldCache = new Map();
            // console.log(this.approvalTemplateObj.mainModelInfo);
            // 关联子表数据
            // console.log(this.tempFormData);
            // 任务中发起审批流，初始化关联子表数据
            if (this.approvalTemplateObj.mainModelInfo) {
                if (this.approvalTemplateObj.mainModelInfo.tempFormData) {
                    for (let i = 0; i < this.approvalTemplateObj.mainModelInfo.tempFormData.length; i++) {
                        let temData = cloneDeep(this.approvalTemplateObj.mainModelInfo.tempFormData[i]);
                        this.tempFormData.push(temData);
                    }
                    // 任务中再次发起审批流，查询历史数据的关联子表数据
                    this.reloadHisData();
                }
            }
            // console.log(this.tempFormData);
            // this.forms.forEach(item => {
            //     item.activeName = 'first';
            //     if (item && item.fieldsList) {
            //         item.fieldsList.forEach(element => {
            //             // 处理权限字段
            //             if (element.options && element.options.ext2) {
            //                 let curObj = JSON.parse(element.options.ext2);
            //                 element.formFieldAuth = curObj.formFieldAuth;
            //                 element.approveFieldAuth = curObj.approveFieldAuth;
            //             }
            //         });
            //     }
            // });
            this.formArray = cloneDeep(this.forms);
            // console.log(this.formArray);
            this.initPage();
        },
        methods: {
            // 任务中发起审批流，驳回后再次发起，加载驳回的那条数据的关联子表数据
            async reloadHisData () {
                if (this.approvalTemplateObj.mainModelInfo.instanceId) {
                    // console.log(this.approvalTemplateObj.mainModelInfo.relateModelList);
                    // if (this.approvalTemplateObj.mainModelInfo.relateModelList) { // 暂时只支持加载第一个关联子表
                    // let selectedModel = this.approvalTemplateObj.mainModelInfo.relateModelList[0];
                    let mainFormDataId = this.approvalTemplateObj.mainModelInfo.instanceId;
                    let mainFormId = this.approvalTemplateObj.mainModelInfo.formId;
                    if (this.approvalTemplateObj.mainModelInfo.relateModelList) {
                        for (let idx = 0; idx < this.approvalTemplateObj.mainModelInfo.relateModelList.length; idx++) {
                            let selectedModel = this.approvalTemplateObj.mainModelInfo.relateModelList[idx];
                            let param = {};
                            param.mainFormDataId = mainFormDataId;
                            param.mainFormId = mainFormId;
                            // param.mainFormDataId = this.approvalTemplateObj.mainModelInfo.instanceId;
                            // param.mainFormId = selectedModel.mainFormId;
                            param.formId = selectedModel.formId;
                            param.modelId = selectedModel.id;
                            let retData = await getModelFormReportList(Object.assign({}, {
                                currentPage: 0,
                                pageSize: 30
                            }, param));
                            // 关联了主表的关联字段
                            let linkFields = retData.otherData.linkFieldList;
                            let fieldsList = retData.otherData.fieldsList;
                            let attributes = {};
                            if (fieldsList) {
                                for (let i = 0; i < fieldsList.length; i++) {
                                    let field = fieldsList[i];
                                    attributes[field.id] = field.type;
                                }
                            }
                            // this.pageData = [];
                            if (retData.data) {
                                let isFilter = false;// 是否重复数据需要过滤
                                let idx = 0;
                                retData.data.forEach(item => {
                                    isFilter = false;
                                    idx = 0;
                                    let jsonObj = JSON.parse(item);
                                    if (this.tempFormData) {
                                        for (var i = 0; i < this.tempFormData.length; i++) {
                                            let tempData = this.tempFormData[i];
                                            if (tempData.formId === selectedModel.formId && tempData.forms[0].values.id === jsonObj.id) { // 过滤掉重复的数据
                                                isFilter = true;
                                                idx = i;
                                                jsonObj = tempData.forms[0].values;
                                                break;
                                            }
                                        }
                                    }
                                    // if (isFilter) {
                                    //     return true;
                                    // }
                                    let formData = {
                                        forms: [
                                            {
                                                ext1: 0,
                                                colSpan: 1,
                                                formId: selectedModel.formId,
                                                values: {},
                                                attributes: cloneDeep(attributes)
                                            }
                                        ]
                                    };
                                    formData.modelId = selectedModel.id;
                                    formData.formId = selectedModel.formId;

                                    let uuid = getUUID(16, 16);
                                    jsonObj.id = uuid;
                                    jsonObj.rowspan = 1;
                                    jsonObj.num = 1;
                                    jsonObj.isOldData = false;
                                    jsonObj.modelId = selectedModel.id;
                                    jsonObj.formId = selectedModel.formId;
                                    // 找到关联字段，一般只有一个，并清空值
                                    if (linkFields) {
                                        for (let i = 0; i < linkFields.length; i++) {
                                            let linkFieldId = linkFields[i].id;
                                            delete jsonObj[linkFieldId];
                                            delete jsonObj[linkFieldId + '-view'];
                                            delete jsonObj[linkFieldId + '-link'];
                                        }
                                    }
                                    formData.forms[0].values = jsonObj;
                                    if (isFilter) {
                                        this.tempFormData[idx].forms[0].values = jsonObj;
                                    } else {
                                        this.tempFormData.push(formData); // 主数据保存后再保存的关联表单数据
                                    }
                                });
                            }
                        }
                    }
                }
            },
            handleFromDataFilter (index, form) {
                this.loadTimer = new Date().getTime();
                this.currentModelId = form.modelId;
                this.isShowDataFilterDialog = true;
            },
            isShowBtn (obj) {
                if (!this.approvalStatus) {
                    return false;
                } else {
                    // let fieldList = obj.fieldsList;
                    // for (let i = 0; i < fieldList.length; i++) {
                    //     let field = fieldList[i];
                    //     if (field.options.formulaExp !== undefined && ((field.options.formulaExp.indexOf(';') !== -1) || (field.options.formulaExp.indexOf(',') !== -1))) {
                    //         return true;
                    //     }
                    // }
                    // if (this.showRelateFormTab) { //
                    //     return true;
                    // }
                }
            },
            async handleClick (form) {
                if (form.activeName === 'second' && !form.modelFormDetaul) {
                    let param = {instanceId: this.instances.id, formId: form.id};
                    let res = await getModelFormDetail(param);
                    if (res) {
                        form.modelFormDetaul = JSON.parse(res.formValues);
                    }
                    this.formArray = cloneDeep(this.formArray);
                }
            },
            async initPage () {
                this.isShowForm = true;
                if (this.formArray && this.formArray.length > 0) {
                    this.collapseActiveName = this.formArray[0].id;// 默认打开第一个表单
                }
                this.approvalBaseActiveName = 'approvalBaseItem';
                if (this.btnMode === 1) {
                    this.approvalRemarksStyle = 'approvalRemarksStyle';
                    this.approvalBaseActiveName = 'approvalBaseItem';
                } else {
                    this.approvalRemarksStyle = '';
                }
                this.loadTimerRelate = new Date().getTime();
                this.getModelListByMainFormId();
            },
            handleChangeCollapse3 (val) {
                if (val) {
                    this.approvalBaseActiveName = '';
                    this.approvalUserActiveName = '';
                    this.approvalSettingActiveName = '';
                    this.approvalRecordActiveName = '';
                } else {
                    this.approvalBaseActiveName = 'approvalBaseItem';
                    this.approvalRecordActiveName = 'approvalRecordItem';
                }
            },
            loadLinkData (data, targetField) {
                for (let index = 0, len = this.formArray.length; index < len; index++) {
                    if (this.formArray[index].fieldsList && this.formArray[index].fieldsList.length > 0) {
                        for (var i = 0; i < this.formArray[index].fieldsList.length; i++) {
                            let tempField = this.formArray[index].fieldsList[i];
                            if (targetField.id === tempField.id) {
                                this.$refs['fieldItemChild' + i][0].initAddLinkData(data);
                            }
                        }
                    }
                }
            },
            async refreshViewField (relateModelMap) {
                // this.loadTimerField = new Date().getTime();
                this.cacheRelateModelMap = relateModelMap;
                if (relateModelMap && relateModelMap.size > 0) { // 级联显示子表单控制
                    this.relateModelMap = new Map();
                    this.relateModelMap = relateModelMap;
                    if (this.relateModelList) {
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let model = this.relateModelList[i];
                            if (relateModelMap.has(model.id)) {
                                model.hiddenElement = !relateModelMap.get(model.id);
                                //   this.showRelateFormTab = relateModelMap.get(model.id);
                                if (relateModelMap.get(model.id)) {
                                    this.showRelateFormTab = true;
                                    //   await this.renderModelFormList(model);
                                }
                                //   if (this.showRelateFormTab) {
                                //       await this.renderModelFormList(model);
                                //   }
                            }
                        }
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let cur = this.relateModelList[i];
                            if (!cur.hiddenElement) {
                                this.relateFormTabName = cur.id;
                                await this.renderModelFormList(cur);
                                break;
                            }
                        }
                    }
                } else {
                    this.loadTimerField = new Date().getTime();
                }
            },
            getSubformName (formData, field) {
                if (Array.isArray(formData[field.id])) {
                    return field.name + '(' + formData[field.id].length + ')';
                } else {
                    return field.name + '(0)';
                }
            },
            isShowNormalField (field, index, formData) {
                let subFormViewMode = formData.values['subFormViewMode'];
                if (subFormViewMode !== 0 && (formData.ext1 === 1 || subFormViewMode === 1)) { // 子表单页签模式
                    if (field.type === 'subform') {
                        return false;
                    } else {
                        return true;
                    }
                } else if (formData.ext1 === 0 || !subFormViewMode || subFormViewMode === 0) { // 子表单正常模式
                    return true;
                }
            },
            async showModelDetail (form, index) {
                if (this.instances.id) {
                    let param = {instanceId: this.instances.id, formId: form.id};
                    let res = await getModelFormDetail(param);
                    if (res) {
                        let formData = await getAppAssignList({
                            currentPage: 1,
                            pageSize: 500,
                            modelId: res.modelId,
                            mode: 1 // 已授权
                        });
                        let userList = formData.data;
                        let isCan = false;
                        let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                        let currentUserInfo = JSON.parse(currentUserStr);
                        userList.forEach(row => {
                            if (row.userId === currentUserInfo.userId) {
                                isCan = true;
                                var url = '/linkFormDetail/' + res.modelId + '/' + res.formId + '/' + res.id;
                                if (window.location.href.indexOf('#/') > -1) {
                                    // 本地访问路径
                                    url = '#' + url;
                                } else {
                                    url = '/bpm' + url;
                                }
                                window.open(url, '_blank');
                            }
                        });
                        if (!isCan) {
                            this.messageTip('您没有配置该表单模型权限，无法查看详情数据', 'warning');
                        }
                    }
                }
            },
            async getModelListByMainFormId () {
                if (this.forms[0] && this.forms[0].id) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let modelList = await getModelListByMainFormId(this.forms[0].id);
                    this.relateModelList = modelList;
                    if (this.relateModelList && this.relateModelList.length > 0) {
                        // console.log(this.formInfo);
                        this.showRelateFormTab = true;
                        // 默认打开第一个关联表单数据
                        this.relateFormTabName = this.relateModelList[0].id;
                        this.renderModelFormList(this.relateModelList[0]);
                    } else {
                        this.showRelateFormTab = false;
                    }
                    loading.close();
                }
            },
            async renderModelFormList (model) {
                // 主表的formid
                model.mainFormId = this.forms[0].id;
                // 主表当前数据id
                model.mainFormDataId = null;
                this.formInfo = this.forms[0];
                this.formInfo.formId = model.mainFormId;
                let isReStartApproval = false;
                if (this.instances.formObj.instance) {
                    let tempInstanceId = this.instances.id;
                    if (this.instances.oldApproveInstanceId) {
                        tempInstanceId = this.instances.oldApproveInstanceId;
                        isReStartApproval = true;
                    }
                    let param = {instanceId: tempInstanceId, formId: model.mainFormId};
                    let res = await getModelFormDetail(param);
                    if (res) {
                        model.mainFormDataId = res.id;
                    }
                }
                // this.loadTimerRelate = new Date().getTime();
                // console.log(model);
                setTimeout(() => {
                    // 调用子组件的方法
                    if (this.$refs['relateModelList' + model.id]) {
                        this.$refs['relateModelList' + model.id][0].renderFormList(model, null, isReStartApproval);
                    }
                }, 0);
            },
            async handleRelateFormTabClick (tab, event) {
                this.relateFormTabName = tab.name;
                for (var i = 0; i < this.relateModelList.length; i++) {
                    let model = this.relateModelList[i];
                    if (model.id === this.relateFormTabName) {
                        this.renderModelFormList(model);
                    }
                }
            },
            asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId, index) {
                // console.log(index);
                if (selectTableColumns && Array.isArray(selectTableColumns)) {
                    let targetFormFieldlist = this.forms[index].fieldsList;
                    selectTableColumns.forEach(fieldObj => {
                        let sourceFieldLabel = fieldObj.label;
                        targetFormFieldlist.forEach(element => {
                            // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                            if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                                if (element.options.synLinkFormFieldId) {
                                    if (element.options.synLinkFormFieldId === fieldObj.id) {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                } else {
                                    if (sourceFieldLabel === element.name && element.type === 'text') {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                }
                            }
                        });
                    });
                    selectTableColumns.forEach(fieldObj => {
                        if (fieldObj.type === 'subform') {
                            // console.log(fieldObj);
                            // console.log(currentlinkFieldId);// 当前表单的关联字段id
                            targetFormFieldlist.forEach(element => {
                                // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                                if (element.options.dataSourceFieldId && element.options.dataSourceFieldId === currentlinkFieldId) {
                                    if (element.options.dataSourceSubFieldId) {
                                        if (element.options.dataSourceSubFieldId === fieldObj.id) {
                                            if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                                                for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
                                                    let tempField = this.forms[index].fieldsList[i];
                                                    if (element.id === tempField.id) {
                                                        this.$refs['fieldItemChild' + i][0].reSetSelectOptions(element, fieldObj, sourceData);
                                                    }
                                                }
                                            }
                                            // this.reSetSelectOptions(element, fieldObj, sourceData, index);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
                for (let i = 0; i < this.forms.length; i++) {
                    let form = this.forms[i];
                    let field = form.fieldsList.find(element => element.id === currentlinkFieldId);
                    if (field.options.ext2) {
                        let ext2 = field.options.ext2;
                        let ext2Obj = JSON.parse(ext2);
                        if (ext2Obj.automaticRecodeRefField) { // 配置了自动带出
                            let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                            let fieldObj = form.fieldsList.find(element => element.id === automaticRecodeFields);
                            if (fieldObj) {
                                this.getTableFirstRefData(fieldObj, form.fieldsList, index);
                            }
                        }
                    }
                }
            },
            async getTableFirstRefData (fieldObj, fieldsList, index) {
                let refTableData = [];
                let refTableColumn = [];
                this.searchParamsField.searchCondition = [];// 初始化搜索条件
                if (fieldObj.ext1 && this.searchParamsField.searchCondition.length === 0) { // 默认筛选值
                    let obj = JSON.parse(fieldObj.ext1);
                    this.defaultConditonsMap = new Map();
                    for (let key in obj) {
                        obj[key]['modelId'] = fieldObj.options.config.form.modelId;
                        this.searchParamsField.searchCondition.push(obj[key]);
                        this.defaultConditonsMap.set(obj[key].id, obj[key]);
                    }
                    this.searchCondition = this.searchParamsField.searchCondition;
                }
                // 任务表单内选择关联数据，默认从前3000条数据中进行筛选。
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await this.setDefaultConditionRef(fieldObj);
                for (let i = 0; i < this.searchParamsField.searchCondition.length; i++) {
                    let defaultCondition = this.searchParamsField.searchCondition[i];
                    if (defaultCondition.operateType === 7) { // 从表单字段值取值搜索
                        let searchvalue = this.formData[defaultCondition.valueFieldId];
                        let cur = fieldsList.find(element => element.id === defaultCondition.valueFieldId);
                        let searchvalueView = '';
                        if (cur.type === 'category' || cur.type === 'select') {
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-view'];
                            let options = defaultCondition.options.config.options;
                            for (let i = 0; i < options.length; i++) {
                                let item = options[i];
                                if (item.title === searchvalueView) {
                                    searchvalue = item.value;
                                }
                            }
                        } else if (cur.type === 'department') {
                            searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                        }
                        if (searchvalue) {
                            defaultCondition.conditionValue = searchvalue;
                            defaultCondition.conditionValueView = searchvalueView;
                            defaultCondition.operateType = 1;
                        }
                    }
                }
                // 处理关联字段值的搜索
                let formData = await getModelFormReportList({
                    currentPage: 1,
                    pageSize: 1,
                    modelId: fieldObj.options.config.form.modelId,
                    formId: fieldObj.options.config.form.formId,
                    isRelationSearch: true,
                    isFromFieldItemLink: true, // 是否进行关联字段的表单数据查询
                    processInstanceId: this.processInstanceId,
                    searchCondition: this.searchParamsField.searchCondition
                });
                if (formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    refTableData = tableDatas;
                    loading.close();
                }
                if (formData.otherData) {
                    refTableColumn = formData.otherData.tableColumns;
                }
                //   this.loadTimer = new Date().getTime();
                if (fieldObj.options.config.form.selectTableHeaderFields) { // 配置了关联列表模型显示表头
                    let cacheTableColumns = [];
                    for (let i = 0; i < refTableColumn.length; i++) {
                        let cur = refTableColumn[i];
                        if (fieldObj.options.config.form.selectTableHeaderFields.indexOf(cur.id) !== -1) {
                            cacheTableColumns.push(cur);
                        }
                    }
                    refTableColumn = cacheTableColumns;
                }
                if (refTableData.length > 0) {
                    let param = {row: refTableData[0]};
                    this.handelSelectRefRow(param, fieldObj, refTableColumn, index);
                }
            },
            handelSelectRefRow (params, fieldObj, refTableColumn, index) { // TODO
                let selData = cloneDeep(params.row);
                let selectTableData = [selData];// 复制当前选中数据
                let linkData = this.setLinkTableData(refTableColumn, selectTableData[0]);
                let curFieldData = {
                    modelId: fieldObj.options.config.form.modelId,
                    tableColumns: refTableColumn,
                    tableData: [linkData]
                };
                this.formData[index].values[fieldObj.id] = curFieldData;
            },
            setLinkTableData (selectTableColumns, sourceFormObj) { // 增加关联字段显示字段的冗余字段数据
                let linkData = {};
                if (sourceFormObj) {
                    linkData['id'] = sourceFormObj.id;
                    if (selectTableColumns && selectTableColumns.length > 0) {
                        let selectcolumns = cloneDeep(selectTableColumns);
                        // console.log(selectcolumns);
                        selectcolumns.forEach(item => {
                            if (item.type === 'dictionary' || item.type === 'businessTree' || item.type === 'department') {
                                // -tree
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-tree'] = sourceFormObj[item.id + '-tree'];
                            } else if (item.type === 'user') {
                                // -user
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-user'] = sourceFormObj[item.id + '-user'];
                            } else if (item.type === 'category' || item.type === 'select' || item.type === 'file' || item.type === 'process' || item.type === 'address' || item.type === 'cascader' || item.type === 'role') {
                                // -view
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'calculation' || item.type === 'number' || item.type === 'text' || item.type === 'serialNumber' || item.type === 'date') {
                                linkData[item.id] = sourceFormObj[item.id];
                            } else if (item.type === 'link') {
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'subform') {
                                linkData[item.id] = sourceFormObj[item.id];
                            }
                        });
                    }
                }
                return linkData;
            },
            async setDefaultConditionRef (fieldObj) {
                if (fieldObj.options.ext3 && fieldObj.options.ext3 === '1' && !isEmpty(this.defaultConditonsMap)) { // 设置过滤条件为固定模式
                    if (this.searchParamsField.searchCondition && Array.isArray(this.searchParamsField.searchCondition)) {
                        let defaultConditons = [];
                        this.searchParamsField.searchCondition.forEach(conditiontObj => {
                            if (this.defaultConditonsMap.has(conditiontObj.id)) {
                                let defaultCondition = this.defaultConditonsMap.get(conditiontObj.id);
                                if (defaultCondition && defaultCondition.conditionValue) {
                                    defaultConditons.push(defaultCondition);
                                } else {
                                    defaultConditons.push(conditiontObj);
                                }
                            } else {
                                defaultConditons.push(conditiontObj);
                            }
                        });
                        if (!isEmpty(defaultConditons)) {
                            this.searchParamsField.searchCondition = defaultConditons;
                        }
                    }
                }
                if (fieldObj.options.ext2) {
                    let def = JSON.parse(fieldObj.options.ext2);
                    if (def.linkConfig) {
                        let linkConfig = JSON.parse(def.linkConfig);
                        if (linkConfig.linkConfigState) { // 需要过滤数据
                            this.searchParamsField.searchCondition = [];
                            let key = linkConfig.id + '-link';
                            let value = this.formData[key];
                            let curObj = JSON.parse(linkConfig.linkFieldObj);
                            curObj.conditionValue = value;
                            curObj.operateType = 2;
                            this.searchParams.searchCondition.push(curObj);
                        }
                    }
                }
                await this.setLinkLimitDataRef(fieldObj);
            },
            async setLinkLimitDataRef (fieldObj) {
                if (fieldObj.options.ext2) { // 子表单的值进行约束，例如只能查看自己作为项目成员参与的项目列表
                    let json = JSON.parse(fieldObj.options.ext2);
                    if (json.limitData === true && json.limitFieldDataArray && json.limitFieldDataArray.length > 0) {
                        let relateFormId = fieldObj.options.config.form.formId; // 关联字段的关联表单id
                        let formData = await getFormConfig(relateFormId);
                        if (formData) {
                            let fieldsList = formData.fieldsList;
                            if (fieldsList && fieldsList.length > 0) {
                                let conditonsMap = new Map();
                                for (let i = 0; i < json.limitFieldDataArray.length; i++) {
                                    let limitField = json.limitFieldDataArray[i];
                                    if (limitField.subFormFieldId) {
                                        let linkPropFieldId = limitField.linkPropFieldId;// 子表单字段
                                        let subFormFieldId = limitField.subFormFieldId;
                                        conditonsMap.set(linkPropFieldId, linkPropFieldId + ',' + subFormFieldId);
                                    }
                                }
                                for (let k = 0; k < fieldsList.length; k++) {
                                    let curfield = fieldsList[k];
                                    if (curfield.type === 'subform' && conditonsMap.has(curfield.id)) {
                                        let targetStr = conditonsMap.get(curfield.id);
                                        curfield.filterMainFieldId = targetStr.split(',')[0];
                                        curfield.filterSubField = targetStr.split(',')[1];
                                        this.searchParamsField.searchCondition.push(curfield);
                                    }
                                }
                            }
                        }
                    }
                }
            },
            // 修改配置了关联映射的字段值
            updSynLinkFieldData (element, fieldObj, sourceData, index) {
                // console.log(element);
                let type = fieldObj.type;
                let sourceValueKey = ''; // 对应userId等唯一性值
                let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
                let sourceDepartmentValueKey = ''; // 对应部门等唯一性值
                let can = false; // 是否支持级联显示
                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                    // -tree
                    can = true;
                    sourceDepartmentValueKey = sourceData[fieldObj.id];
                    sourceValue = sourceData[fieldObj.id + '-tree'];
                } else if (type === 'user') {
                    // -user
                    can = true;
                    sourceValueKey = sourceData[fieldObj.id];
                    sourceValue = sourceData[fieldObj.id + '-user'];
                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                    // -view
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                } else if (type === 'link') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'subform') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                }
                if (can) {
                    if (element.type === 'text') {
                        this.formData[index].values[element.id] = sourceValue;
                        this.formData[index].values[element.id + '-view'] = '';
                    } else if (element.type === 'number' || element.type === 'calculation') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[index].values[element.id] = sourceValue;
                            this.formData[index].values[element.id + '-view'] = '';
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-view'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'user') {
                        // console.log(element);
                        // fieldId-user: trueName ，fieldId: userId
                        // console.log(sourceValue);
                        // console.log(sourceValueKey);
                        if (!isEmpty(sourceValue)) {
                            this.formData[index].values[element.id] = sourceValueKey;
                            this.formData[index].values[element.id + '-user'] = sourceValue;
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-user'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'department') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[index].values[element.id] = sourceDepartmentValueKey;
                            this.formData[index].values[element.id + '-tree'] = sourceValue;
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-tree'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'select') {
                        // console.log(element);
                        if (!isEmpty(sourceValue)) {
                            // 下拉选项值
                            let targetFieldValue = {};
                            let targetFieldOptions = element.options.config.options;
                            for (let i = 0; i < targetFieldOptions.length; i++) {
                                let optionItem = targetFieldOptions[i];
                                if (optionItem.title === sourceValue) {
                                    targetFieldValue = optionItem;
                                    break;
                                }
                            }
                            if (targetFieldValue) {
                                this.formData[index].values[element.id] = targetFieldValue.value;
                                this.formData[index].values[element.id + '-view'] = targetFieldValue.title;
                            }
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-view'] = '';
                        }
                    } else if (element.type === 'subform') {
                        let sourceSubColumns = fieldObj.subColumns;
                        if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
                            sourceSubColumns = fieldObj.options.fieldList;
                            for (let k = 0; k < sourceSubColumns.length; k++) {
                                sourceSubColumns[k].label = sourceSubColumns[k].name;
                            }
                        }
                        let taragetSubColumns = element.options.fieldList;
                        let newValue = [];
                        if (!isEmpty(sourceValue)) {
                            for (let i = 0; i < sourceValue.length; i++) {
                                let sourceItemValue = sourceValue[i];
                                let targetItemValue = {};
                                // console.log(sourceItemValue);
                                for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                    let targetColumn = taragetSubColumns[j];
                                    for (let k = 0; k < sourceSubColumns.length; k++) {
                                        let sourceColumn = sourceSubColumns[k];
                                        if (targetColumn.label === sourceColumn.label) {
                                            if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                                // -tree
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                            } else if (sourceColumn.type === 'user') {
                                                // -user
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                            } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                                // -view
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                            } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                            }
                                            break;
                                        }
                                    }
                                }
                                if (!isEmpty(targetItemValue)) {
                                    newValue.push(targetItemValue);
                                }
                            }
                            // console.log(newValue);
                            this.formData[index].values[element.id] = newValue;
                        } else {
                            this.formData[index].values[element.id] = '';
                        }
                    }
                }
            },
            getTempFormData () {
                if (this.approvalTemplateObj.mainModelInfo) {
                    this.tempFormData = this.approvalTemplateObj.mainModelInfo.tempFormData;
                    if (isEmpty(this.tempFormData)) { // 如果为空则再取pageData的值做校验
                        if (this.relateModelList && this.relateModelList.length > 0) {
                            let res = this.relateModelList.find(element => element.id === this.relateFormTabName);
                            if (res) {
                                let refKey = 'relateModelList' + res.id;
                                if (this.$refs[refKey][0]) {
                                    let obj = this.$refs[refKey][0].getTempData();
                                    if (obj && obj.length > 0) {
                                        this.tempFormData = obj;
                                    }
                                }
                            }
                        }
                    }
                }
                return isEmpty(this.tempFormData) ? null : this.tempFormData;
            },
            getRelateModelList () {
                return this.relateModelList;
            },
            async handelShowForms () { // 任务表单库
                let param = {processInstanceId: this.instances.id};
                let res = await getProcessTaskInfo(param);
                if (res && res.state === 'success') {
                    this.busiProcessInfo.processInstanceId = res.busiProcessInstanceId;
                    this.busiProcessInfo.deploymentId = res.busiDeploymentId;
                    this.busiProcessInfo.instanceName = res.processInstanceName;
                    this.busiProcessInfo.serviceName = res.busiServiceName;
                    this.isShowForms = true;
                }
            },
            handleShowApprovalRecordList (index) {
                this.loadTimer = new Date().getTime();
                this.currentModeInstanceId = this.formData[index].values.id;
                this.isShowApprovalRecordListDialog = true;
            },
            async handelDownloadReport () {
                let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
                this.downloadFlg = true;
                await this.download(url);
                setTimeout(() => { // 导出按钮转圈圈关闭
                    this.downloadFlg = false;
                }, 5000);
            },
            async download (url) {
                let param = {
                    modelId: '3e7dee0b05d3496687b2401fb44e2378', //  TODO: 20210827 这里需要根据配置的报表id来动态赋值，目前是写死了，后续做成可以配置的
                    formDataId: '', // 单条数据导出需要数据id
                    isCurrentExport: 1
                };
                // TODO: 20210827 这里需要根据配置的任务id来动态赋值，目前是写死了，后续做成可以配置的
                let pkMap = await getProcessInstanceTaskPkId({processInstanceId: this.approvalTemplateObj.busiProcessInstanceId, taskId: 'sid-8E064AFE-8A9F-4427-A117-BCB7DAF52A0B'});
                if (pkMap && pkMap.reportExportprocessDataId) {
                    param.reportExportprocessDataId = pkMap.reportExportprocessDataId;
                }
                param.page = JSON.stringify({currentPage: 1, pageSize: 10, totalPageNum: 1});
                let res = await getExcelDataExportId(param);
                if (res && res.data) {
                    url = `${API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID}`;
                    url = url.replace(':exportId', res.data);
                }
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            getNewApprovalformField () {
                return this.formArray;
            },
            refTempFormData (obj) {
                // this.approvalTemplateObj.mainModelInfo.tempFormData = obj;
                this.renderCalculationField(obj);
            },
            async renderCalculationField (tempFormData) { // 主子表情况下，主表里有计算字段使用了子表的数据，还没提交后台时提前计算逻辑
                if (this.forms && this.forms.length > 0) {
                    let formInfo = this.forms[0];// 默认第一个
                    let isRefresh = false;
                    if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                        for (var i = 0; i < formInfo.fieldsList.length; i++) {
                            let tempField = formInfo.fieldsList[i];
                            if (tempField.type === 'calculation' && tempField.isView && tempField.ext2 !== '1') {
                                // console.log(tempField);
                                let param = {};
                                param.valuesNode = this.formData[0].values;
                                param.formulaExp = tempField.options.formulaExp;
                                param.tempFormData = tempFormData;
                                let res = await getCrossFieldData(param);
                                let finalVal = null;
                                if (res && res.finalVal) {
                                    finalVal = Number(res.finalVal);
                                    this.formData[0].values[tempField.id] = finalVal;
                                    isRefresh = true;
                                }
                            }
                        }
                        if (isRefresh) {
                            this.loadTimerField = new Date().getTime();
                        }
                    }
                }
            }

        }
    };
</script>

<style lang="less">
    .detail-formPop{
        height: 80%;
    }
</style>



// WEBPACK FOOTER //
// src/components/ApprovalForm/ApprovalForm.vue